import { Helmet } from 'react-helmet';
import RequestrefundreportDetail
  from 'src/components/requestrefundreport-detail/RequestrefundreportDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

import RequestrefundreportListToolbar from '../components/requestrefundreport-detail/RequestrefundreportToolbar';

const Requestrefundreport = () => (
  <>
    <Helmet>
      <title>Báo cáo yêu cầu hoàn tiền</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        <RequestrefundreportListToolbar />
        <Box sx={{ pt: 3 }}>
          <RequestrefundreportDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default Requestrefundreport;
